import React, { useEffect, useState } from "react";
import { withRouter, useParams } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CipHeader from "../Components/CipHeader";
import SsrsRep from "../Components/ssrsRep";
import ssrsService from "../services/ssrs-service";
import { Modal } from "react-responsive-modal";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import cogoToast from "cogo-toast";

const Ssrs = () => {
  const [loading, setLoading] = useState(false);
  const [openPopUp, setOpenPopUp] = useState(false);
  const [argumnts, setArgumnts] = useState([]);
  const [reports, setReports] = useState([]);
  const onCloseRepModal = () => setOpenPopUp(false);
  const { type } = useParams();

  const getSsrsReports = async (type) => {
    try {
      setLoading(true);
      let resp = await ssrsService.getSsrsReports(type);
      setReports([...resp].sort((a, b) => a.name.localeCompare(b.name)));
      setLoading(false);
    } catch (e) {
      setLoading(false);
      const { hide } = cogoToast.error(
        "Error getting reports. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };

  useEffect(() => {
    setLoading(false);
    if (type) getSsrsReports(type);
  }, [type]);

  const elems = [];
  reports.forEach((item, i) =>
    elems.push(
      <li className="text-sm  " title={item.name} key={i}>
        <button
          className=" py-2 block whitespace-no-wrap font-semibold truncate"
          onClick={() => {
            setArgumnts(item);
            setOpenPopUp(true);
          }}
        >
          {item.name}
        </button>
      </li>
    )
  );

  return (
    <>
      <CipHeader />
      <div
        className={`inline-block customtop absolute z-50 ${
          loading ? "show" : "hidden"
        }`}
      >
        <Loader
          type="Oval"
          color="#00BFFF"
          height={50}
          width={50}
          timeout={300000} //3 secs
        />
      </div>
      <div className="bg-white w-5/6 mx-auto mt-6 mb-4 rounded shadow-md">
        <div className="tableHeader flex clearboth shadow-md py-8 pl-3 h-24">
          <div className="w-1/2 text-darkclr font-semibold leading-10 ">
            <span className="text-xl">{type} REPORTS</span>
          </div>
        </div>
        <div className=" text-xs usersList gridList">
          <ul style={{ listStyleType: "disc" }} className="w-full py-8 px-12">
            {elems}
          </ul>
        </div>
        <div className="h-1/2">
          <Modal
            open={openPopUp}
            onClose={onCloseRepModal}
            center
            styles={{ modal: { width: "700px", "overflowX":"hidden" } }}
          >
            <SsrsRep
              argumnts={argumnts}
              onCloseRepModal={onCloseRepModal}
            ></SsrsRep>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(Ssrs)
);
